<p-card class="p-card container" [class.proposal-section--valid]="isCompleted && form.valid">
  <h3 i18n>Questionnaire de santé et admissibilité</h3>

  @if (isDev && !isReadonly) {
    <div class="layout--row layout--gap-medium">
      <p-button label="Eligible" class="btn--simulate" (onClick)="simulate(true)"></p-button>
      <p-button label="Eligible with EQ" class="btn--simulate" (onClick)="simulate(true, true)"></p-button>
      <p-button label="Ineligible" class="btn--simulate" (onClick)="simulate(false)"></p-button>
    </div>
  }

  <div id="healthQuestionnaireSection">
    @for (question of questions; track question; let i = $index; let last = $last) {
      <div
        class="flex"
        [ngClass]="{
          'question-ineligible': question.causesIneligibility,
          'question-extra-questionnaire': question.extraQuestionnaire,
        }">
        <div class="mr-2">{{ i + 1 }}.</div>
        <div class="flex-grow-1">
          <em-question
            [question]="question"
            [control]="getFormControl(question.answer.propertyName)"
            [extraControl]="getFormControl(WEIGHT_UNIT_FORM_CONTROL_NAME)"
            [bmi]="bmi"></em-question>
          @if (!last) {
            <p-divider></p-divider>
          }
        </div>
      </div>
    }
  </div>
</p-card>
